import React from "react"

NotFound.propTypes = {}

function NotFound(props) {
  return <div>Not Found</div>
}

export default NotFound
